export const QUESTION_TYPES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  LIST: 'list',
  DATE: 'date',
  NUMBER: 'number',
  EMAIL: 'email',
  AVATAR: 'avatar',
  MULTIVALUE: 'multiValue',
};

export const COUNTRIES = [
  'AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS',
  'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES',
  'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM',
  'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV',
  'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST',
  'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA',
  'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT',
  'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN',
  'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR',
  'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ',
  'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MAR', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MOZ', 'MMR', 'NAM',
  'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK',
  'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU',
  'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN',
  'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA',
  'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL',
  'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY',
  'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE',
];

export const INDUSTRIES = [
  'health', 'fintech', 'food', 'media', 'marketing', 'enterpriseSoftware', 'transportation', 'fashion', 'realEstate',
  'homeLiving', 'education', 'kids', 'energy', 'wellnessBeauty', 'sports', 'hosting', 'gaming', 'travel',
  'semiconductors', 'music', 'eventTech', 'jobsRecruitment', 'security', 'legal', 'robotics', 'telecom', 'dating',
  'serviceProvider', 'engineeringAndManufacturingEquipment', 'space', 'consumerElectronics', 'chemicals',
];

export const SUB_INDUSTRIES = [
  'healthPlatform', 'biotechnology', 'medicalDevices', 'pharmaceutical', 'financialManagementSolutions',
  'wealthManagement', 'payments', 'mortgagesAndLending', 'insurance', 'cryptoAndDefi', 'banking', 'regtech',
  'innovativeFood', 'agritech', 'foodLogisticsAndDelivery', 'inStoreRetailAndRestaurantTech', 'kitchenAndCookingTech',
  'contentProduction', 'publishing', 'socialMedia', 'streaming', 'adtech', 'crmAndSales', 'ecommerceSolutions',
  'marketingAnalytics', 'logisticsAndDelivery', 'mobility', 'vehicleProduction', 'searchBuyAndRent',
  'navigationAndMapping', 'maintenance', 'autonomousAndSensorTech', 'apparel', 'accessories', 'luxury', 'footwear',
  'construction', 'realEstateServices', 'realEstateSoftware', 'workspaces', 'learningToolsAndResources',
  'educationProviders', 'educationManagement', 'cleanEnergy', 'energyEfficiency', 'oilAndGas', 'wasteSolution',
  'water', 'energyProviders', 'energyStorage', 'sportPlatformAndApplication', 'sportingEquipment', 'fitness',
  'sportLeagueAndClub', 'sportMedia', 'sportSupplements', 'consoleAndPcGaming', 'mobileGaming', 'bettingAndGambling',
  'esports', 'boardGames', 'onlineTravelAgency', 'accommodation', 'bookingAndSearch', 'travelAnalyticsAndSoftware',
  'businessTravel', 'publicSafety', 'cloudAndInfrastructure', 'dataProtection', 'identityAndAccess',
  'deviceSecurityAndAntivirus', 'consulting',
];

export const TECHNOLOGIES = [
  'deepTech', 'artificialIntelligence', 'hardware', 'mobileApp', 'machineLearning', 'bigData', 'blockchain',
  'iotInternetOfThings', '3dTechnology', 'computerVision', 'virtualReality', 'recognitionTechnology',
  'augmentedReality', 'connectedDevice', 'nanotech', 'autonomousAndSensorTech', 'deepLearning',
  'naturalLanguageProcessing', 'quantumTechnologies', '3D',
];

export const INCOME_STREAMS = [
  'subscription', 'advertising', 'commission', 'sellingOwnInventory',
];

export const CLIENT_FOCUS = [
  'b2b', 'b2c',
];

export const REVENUES = [
  'saas', 'marketplaceEcommerce', 'manufacturingPhysicalProducts',
];

export const GROWTH_STAGE = [
  'seed', 'earlyGrowth', 'lateGrowth', 'mature',
];

export const INVESTMENT_POLICIES = [
  'ventureCapital', 'privateEquity', 'corporateVentureCapital', 'realEstate', 'privateDebt',
];
